var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPortfolioOld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm0 0",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5h-1.668v-.418c0-.687-.559-1.25-1.25-1.25H9.168c-.691 0-1.25.563-1.25 1.25V7.5H6.25a.42.42 0 0 0-.418.418v1.664c.004.355.156.691.418.926v2.41c0 .687.559 1.25 1.25 1.25h5c.691 0 1.25-.563 1.25-1.25v-2.41c.262-.235.414-.57.418-.926V7.918a.418.418 0 0 0-.418-.418zm-5-.418c0-.23.188-.414.418-.414h1.664c.23 0 .418.184.418.414V7.5h-2.5zm4.168 5.836c0 .23-.188.414-.418.414h-5a.418.418 0 0 1-.418-.414v-2.086h.836v.418a.417.417 0 0 0 .832 0v-.418h2.5v.418a.415.415 0 1 0 .832 0v-.418h.836zm.414-3.336a.416.416 0 0 1-.414.418h-.836v-.418a.416.416 0 1 0-.832 0V10h-2.5v-.418a.415.415 0 0 0-.418-.398.414.414 0 0 0-.414.398V10h-.836a.414.414 0 0 1-.414-.418v-1.25h6.664zm0 0",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPortfolioOld);
export default ForwardRef;